import React from 'react';
import { connect } from 'react-redux';

import { makeGetTaskGroupOpenTasksWithoutMilestone, makeGetProjectCompletedTasksWithoutMilestone } from 'selectors/tasks';

import TasksList from 'components/tasks-list';
import CreateTaskButton from 'components/create-task-button';

const TaskGroupTasksWithoutMilestone = ({ taskGroupId, tasks, onCreateTask, ...props }) => {
    const handleTaskCreate = name => {
        onCreateTask(taskGroupId, name);
    }

    return (
        <React.Fragment>
            <TasksList
                tasks={tasks}
                groupId={taskGroupId}
                {...props}
            />

            {
                onCreateTask ? (
                    <div className="group-foot tour-target-task-create">
                        <CreateTaskButton onCreateTask={handleTaskCreate} />
                    </div>
                ) : null
            }
        </React.Fragment>
    )
}

const makeMapStateToProps = () => {
    const getTaskGroupOpenTasksWithoutMilestone = makeGetTaskGroupOpenTasksWithoutMilestone();
    const getProjectCompletedTasksWithoutMilestone = makeGetProjectCompletedTasksWithoutMilestone();

    return ({ tasks }, ownProps) => {
        const taskGroupTasks = ownProps.taskGroupId === 'completed' ? getProjectCompletedTasksWithoutMilestone(tasks.items, ownProps.projectId) : getTaskGroupOpenTasksWithoutMilestone(tasks.items, ownProps.taskGroupId);

        return {
            tasks: taskGroupTasks.map(task => task.id)
        }
    }
}

export default connect(makeMapStateToProps)(TaskGroupTasksWithoutMilestone);
